<template>
  <div class="dashboard-pages">
    <v-card>
      <v-card-text>
        <h3 class="pb-2 grey--text">{{ $t('Inventory Sections') }}</h3>
        <template v-for="(section, index) in filterSubMenu(sidebarSubLinks['inventory'])">
          <div :key="index">
            <h4 class="grey--text">{{ $t(section.title) }}</h4>
            <ul class="sub-sections-list">
              <li v-for="(link, index) in filterSubMenu(section.groupLinks)" :key="index">
                <span class="px-2">{{ $vuetify.rtl ? '&larr;' : '&rarr;' }}</span>
                <v-tooltip :right="!$vuetify.rtl" :left="$vuetify.rtl">
                  <router-link slot="activator" class="text-capitalize" :to="link.to">{{ $t(link.title) }}</router-link>
                  <span>{{ $t('Manage') }} {{ $t(link.title) }}</span>
                </v-tooltip>
              </li>
            </ul>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'Inventory',

  computed: {
    ...mapGetters({
      sidebarSubLinks: 'dashboard/sidebarSubLinks'
    })
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Inventory Sections'),
      icon: 'fa-dolly'
    })
  },

  methods: {
    filterSubMenu(menu) {
      return menu.filter(item => helpers.userHasSidebarPermissions(item.id))
    }
  }
}
</script>

<style scoped />
